import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginPage } from './pages/login/login.page';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldModule } from '@shared/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { RestorePasswordPage } from './pages/restore-password/restore-password.page';
import { ValidateOtpPage } from './pages/validate-otp/validate-otp.page';
import { CodeInputModule } from './components/code-input/code-input.module';
import { NewPasswordPage } from './pages/new-password/new-password.page';
import { UiModule } from '@migo-apps/ui';
import { EmailParamGuard } from './guards/email/email-param.guard';
import { TranslateModule } from '@ngx-translate/core';
import {
  InputComponent,
  ToggleComponent,
  ButtonComponent,
  IconsComponent,
} from '@migo-apps/migo-uikit-v4';
import { AuthLayout } from '@authentication';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: LoginPage,
        data: { title: 'Iniciar Sesión', subtitle: 'Iniciar Sesión' },
      },
      {
        path: 'restore-password',
        component: RestorePasswordPage,
        data: {
          title: 'Restablecer Contraseña',
          subtitle: 'Restablecer Contraseña',
        },
      },
      {
        path: 'validate-otp',
        component: ValidateOtpPage,
        canActivate: [EmailParamGuard],
        data: { title: 'Validar OTP', subtitle: 'Validar OTP' },
      },
      {
        path: 'new-password',
        component: NewPasswordPage,
        data: { title: 'Nueva Contraseña', subtitle: 'Nueva Contraseña' },
      },
      {
        path: 'activate-account',
        component: NewPasswordPage,
        data: { title: 'Activar Cuenta', subtitle: 'Activar Cuenta' },
      },
      { path: '**', pathMatch: 'full', redirectTo: 'login' },
    ],
  },
];

@NgModule({
  declarations: [
    LoginPage,
    RestorePasswordPage,
    ValidateOtpPage,
    NewPasswordPage,
    AuthLayout,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormFieldModule,
    MatCheckboxModule,
    MatIconModule,
    CodeInputModule,
    UiModule,
    TranslateModule,
    InputComponent,
    ToggleComponent,
    ButtonComponent,
    ButtonComponent,
    IconsComponent,
  ],
})
export class AuthenticationModule {}
